import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from '../components/Reveal';
import IMG from '../data/images';
import { programmes, features } from '../data/siteData';



const Admissions = () => (
  <div>
    <section style={{ paddingTop:130,paddingBottom:70,background:'linear-gradient(135deg,var(--navy),var(--navy-dark))',textAlign:'center',position:'relative',overflow:'hidden' }}>
      <img src={IMG.admission} alt='' style={{position:'absolute',inset:0,width:'100%',height:'100%',objectFit:'cover',opacity:0.12}}/>
      <div style={{position:'relative',zIndex:2}}>
        <h1 style={{ fontFamily:'var(--fh)',fontSize:'2.6rem',color:'#fff' }}><span style={{color:'var(--gold)'}}>Admissions</span> 2026–27</h1>
        <p style={{ color:'rgba(255,255,255,0.6)',maxWidth:500,margin:'12px auto 0',lineHeight:1.8 }}>Begin your child's Finnish education journey. Spaces are limited.</p>
      </div>
    </section>
    <section style={{padding:'90px 24px'}}>
      <div className='container-sm'>
        <Reveal><div className='gold-bar'/><h2 className='sec-heading'>Admission Process</h2><p className='sec-sub'>A simple, transparent 4-step journey.</p></Reveal>
        <div style={{maxWidth:600,margin:'0 auto'}}>
          {[{s:'01',t:'Enquire',d:'Fill out the form or call us. We\'ll respond within 24 hours.'},{s:'02',t:'Campus Visit',d:'A personalised tour to meet teachers and see the spaces.'},{s:'03',t:'Interaction',d:'A gentle, play-based session — no tests, no stress.'},{s:'04',t:'Enrol',d:'Complete formalities and welcome your child to Finland Early Years!'}].map((x,i)=>(
            <Reveal key={i} delay={i*0.1}><div className='card' style={{display:'flex',gap:20,alignItems:'flex-start',marginBottom:16,padding:'24px'}}>
              <div style={{width:48,height:48,borderRadius:'50%',background:'var(--gold)',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:800,color:'var(--navy)',fontFamily:'var(--fh)',flexShrink:0}}>{x.s}</div>
              <div><h3 style={{fontFamily:'var(--fh)',color:'var(--navy)',fontSize:'1.1rem',marginBottom:4}}>{x.t}</h3><p style={{color:'var(--body)',lineHeight:1.7,fontSize:'0.88rem'}}>{x.d}</p></div>
            </div></Reveal>
          ))}
        </div>
      </div>
    </section>
    <section className='sec-cream' style={{padding:'90px 24px'}}>
      <div style={{maxWidth:600,margin:'0 auto'}}>
        <Reveal><div className='gold-bar'/><h2 className='sec-heading'>Admission Enquiry</h2><p className='sec-sub'>Fill in your details — we'll get back within 24 hours.</p></Reveal>
        <Reveal delay={0.1}>
          <div style={{background:'#fff',borderRadius:20,padding:'40px 32px',boxShadow:'var(--shadow-l)'}}>
            <div className='g2' style={{gap:16}}><div className='f-group'><label className='f-label'>Parent Name</label><input className='f-input' placeholder='Full name'/></div><div className='f-group'><label className='f-label'>Phone</label><input className='f-input' placeholder='+91 XXXXX XXXXX'/></div></div>
            <div className='g2' style={{gap:16}}><div className='f-group'><label className='f-label'>Email</label><input className='f-input' type='email' placeholder='your@email.com'/></div><div className='f-group'><label className='f-label'>Child\'s Age</label><input className='f-input' placeholder='e.g., 3 years'/></div></div>
            <div className='f-group'><label className='f-label'>Programme</label><select className='f-select'><option>Select a programme</option>{programmes.map(p=><option key={p.id}>{p.name} ({p.age})</option>)}</select></div>
            <div className='f-group'><label className='f-label'>Message</label><textarea className='f-textarea' placeholder='Any questions?' rows={3}/></div>
            <button className='btn btn-gold btn-full' style={{marginTop:8,padding:16}}>Submit Enquiry</button>
          </div>
        </Reveal>
      </div>
    </section>
  </div>
);
export default Admissions;

